import { LegalPage } from "../components/LegalPage";
import { getAddressLines, getProviderName, legalProfile } from "../legal";

export function Widerruf() {
  return (
    <LegalPage
      title="Widerrufsbelehrung"
      intro={
        <>
          <p>
            Unser Angebot richtet sich ausschließlich an Unternehmer, Freiberufler und vergleichbare
            Organisationen. Für diese B2B-Verträge besteht kein gesetzliches Widerrufsrecht.
          </p>
          <p>Stand: {legalProfile.lastUpdated}</p>
        </>
      }
    >
      <section className="space-y-4">
        <h2 className="text-2xl font-semibold tracking-tight">Kein Widerrufsrecht bei B2B</h2>
        <p className="text-base leading-relaxed text-gray-700">
          Wir schließen Verträge ausschließlich mit Unternehmern im Sinne von § 14 BGB. Für diese
          Verträge sieht das Gesetz kein Widerrufsrecht vor; ein Widerruf nach §§ 312g, 355 BGB ist
          daher ausgeschlossen.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold tracking-tight">Sie sind versehentlich Verbraucher?</h2>
        <p className="text-base leading-relaxed text-gray-700">
          Sollten Sie den Checkout dennoch als Verbraucher gestartet haben, kontaktieren Sie uns
          bitte unmittelbar, damit wir den Vorgang prüfen und gegebenenfalls stornieren können.
        </p>
        <div className="rounded-2xl border border-stone-200 bg-stone-50 p-5 text-base leading-relaxed text-gray-700">
          <p>{getProviderName()}</p>
          {getAddressLines().map((line) => (
            <p key={line}>{line}</p>
          ))}
          <p>E-Mail: {legalProfile.email}</p>
        </div>
      </section>
    </LegalPage>
  );
}
